import styled from 'styled-components';

import { selfOrFunction } from '../../utils';

import { ButtonGroupProps } from './types';

export const ButtonGroupContainer = styled.div<ButtonGroupProps>`
  display: inline-flex;
  align-items: center;

  border-radius: 10px;
  gap: ${({ theme }) => theme.mosaiq.spacing(0.5)}px;
  padding: ${({ theme }) => theme.mosaiq.spacing(0.5)}px;
  background-color: ${(props) =>
    selfOrFunction(props, props.backgroundColor) ?? props.theme.mosaiq.colors.grey};

  & > button:not(:last-child) {
    margin-right: ${({ theme }) => theme.mosaiq.spacing(0.5)}px;
  }
`;
